<section class="investment-wrapper">
    <article *ngFor="let investmentOption of investmentOptions;" class="investment-product">
        <span class="product-name">
            {{investmentOption.name}}
        </span>
        <div class="product-attribute">
            <ng-container *ngIf="investmentOption.maturity_days; else no_maturity_days">
                <span class="product-label">
                    Maturity
                    <app-tooltip class="tooltip-section" placement="bottom">
                        <i class="infoIcon material-icons" trigger>info_outline</i>
                        <div class="tooltip-max" content>
                            <strong class="text-black">Maturity</strong> 
                            months is the period during which the 
                            <strong class="text-black">finzyFLEX</strong> 
                            investments cannot be withdrawn to bank account.
                        </div>
                    </app-tooltip>
                </span>
            </ng-container>

            <ng-template #no_maturity_days>
                <span class="product-label">
                    MHP
                    <app-tooltip class="tooltip-section" placement="bottom"><i class="infoIcon material-icons"
                        trigger>info_outline</i>
                        <div class="tooltip-max" content>Minimum Holding Period (<strong class="text-black">MHP</strong>) is the period of months during which the <strong class="text-black">finzyFLEX</strong> investments cannot be withdrawn to bank account.</div>
                    </app-tooltip>
                </span>
            </ng-template>

            <span class="product-value">
                {{investmentOption.mph}}m
            </span>
        </div>
        <div class="product-attribute">
            <span class="product-label">
                Interest:
            </span>
            <ng-container *ngIf="investmentOption.maturity_days; else default_interest_text">
                <span class="product-value">
                    upto <strong>{{investmentOption.interest}}%</strong> 
                    <strong class="grey-text"> p.a. (20% for 18 months)</strong>
                </span>
            </ng-container>
            <ng-template #default_interest_text>
                <span class="product-value">
                    upto <strong>{{investmentOption.interest}}%</strong> <strong class="grey-text"> p.a</strong>
                </span>
            </ng-template>
        </div>
    </article>
</section>